<template>
  <content-container>
    <div class="show-margin">
      <section>
        <h1>Первая секция, заголовок 1</h1>
        <p class="text-secondary">
          Веселеньким желтеньким покажем margin секции, а этот текст имеет класс
          <strong>text-secondary</strong>.
        </p>
        <p>
          А это пример обычного параграфа. Proin non odio eu nibh sollicitudin
          lobortis id vitae nisi. Praesent a pretium dui. Fusce orci lorem,
          dignissim eu mi id, placerat dignissim tellus. Suspendisse potenti.
          Duis mattis nibh vitae massa faucibus blandit. Ut finibus bibendum
          blandit. Vivamus commodo quam in consequat tempor. Nullam ultricies
          diam ex, sit amet lacinia tellus aliquet id.
        </p>
      </section>
      <section>
        <h2>Вторая секция, заголовок 2</h2>
        <p>
          Веселенький желтенький проявляет текущий <strong>margin</strong> между
          двумя секциями. А здесь у нас <a href="/">пример ссылки</a>, импользуется цвет "primary". Etiam consequat odio accumsan dui hendrerit finibus.
          Sed consectetur rhoncus justo, eu molestie elit aliquam at. Donec
          pretium facilisis nulla et ultricies. Donec diam ipsum, laoreet et
          ultricies nec, iaculis eu risus. Vivamus vel nibh in purus finibus
          egestas.
        </p>
        <h3>Вторая секция, заголовок 3</h3>
        <p>
          Morbi tempor non sem non pharetra. Donec iaculis dui tincidunt,
          facilisis nisi imperdiet, lobortis erat. Vivamus et quam eget nibh
          efficitur facilisis sit amet tincidunt ligula. Aenean <a href="/">varius fermentum</a>
          dignissim. Pellentesque ac arcu id nisi condimentum finibus. Aliquam
          erat volutpat. Integer feugiat enim vel odio scelerisque consectetur.
          Pellentesque finibus, metus at auctor dignissim, diam purus tincidunt
          quam, eu gravida est neque non diam.
        </p>
        <h4>Вторая секция, заголовок 4</h4>
        <p>
          Proin non egestas tellus. Vestibulum a mauris rutrum augue consectetur
          condimentum et dapibus leo. Praesent mauris orci, fermentum ut lacinia
          sed, pulvinar vel dui. Vestibulum rutrum sed orci quis egestas.
          Vestibulum at ante sagittis nisi viverra congue. Fusce lacinia mi ac
          ante tempus laoreet. Etiam auctor eleifend euismod. Donec mollis velit
          in purus blandit, sit amet tincidunt nulla venenatis. Integer felis
          risus, pellentesque pulvinar aliquam pharetra, euismod in nulla.
        </p>
        <p>И конечно же нужно проверить списки:</p>
        <ul>
          <li>Самая главная фича идет первой.</li>
          <li>Дальше следуют "обычные" фичи продукта.</li>
          <li>Таких фич может быть много.</li>
          <li>Их можно менять местами и следить за рекцией поситителей.</li>
        </ul>
      </section>
    </div>
  </content-container>
</template>

<script>
import ContentContainer from '../ContentContainer.vue';
// @ is an alias to /src

export default {
  components: { ContentContainer },
  name: "Font",
};
</script>

<style scoped>
.show-margin {
  background-color: #f9ffc9;
  display: flow-root;
}
.show-margin > * {
  background-color: white;
}
</style>